module.exports = __webpack_public_path__ + "img/investment-plan@2x.6343ee90.webp";